const DEFAULT_MAX_LENGTH = 28;

/**
 * Shortens a long file name for display, keeping the leading characters and the
 * extension (e.g. `really-long-learner-lis….csv`) so it never blows out a
 * fixed-width container like a chip. Names at or under `maxLength` are returned
 * unchanged.
 * @param name - The file name to shorten.
 * @param maxLength - Maximum length of the returned string (including the ellipsis).
 */
export const truncateFileName = (name: string, maxLength: number = DEFAULT_MAX_LENGTH): string => {
  if (name.length <= maxLength) return name;
  const dotIndex = name.lastIndexOf('.');
  const extension = dotIndex > 0 ? name.slice(dotIndex) : '';
  const head = name.slice(0, Math.max(1, maxLength - extension.length - 1));
  return `${head}…${extension}`;
};

export default truncateFileName;
